export const TAG_COLORS = [
  'purple',
  'pink',
  'red',
  'orange',
  'yellow',
  'green',
  'teal',
  'blue',
  'gray',
  'purple-light',
  'pink-light',
  'red-light',
  'orange-light',
  'yellow-light',
  'green-light',
  'teal-light',
  'blue-light',
  'gray-light',
] as const

export type TagColor = (typeof TAG_COLORS)[number]

/**
 * Maps legacy hex color values from @bufferapp/ui/style/colors
 * to the new Popcorn Tag color names.
 * Lookup is case-insensitive (converts input to lowercase).
 */
const LEGACY_HEX_TO_TAG_COLOR: Record<string, TagColor> = {
  '#9c2bff': 'purple',
  '#d925ac': 'pink',
  '#e0364f': 'red',
  '#ff702c': 'orange',
  '#fade2a': 'yellow',
  '#87c221': 'green',
  '#00c8cf': 'teal',
  '#1f35b3': 'blue',
  '#000000': 'gray',
  '#d7aaff': 'purple-light',
  '#f0a8de': 'pink-light',
  '#f3afb9': 'red-light',
  '#ffc6ab': 'orange-light',
  '#fdf2aa': 'yellow-light',
  '#cfe7a6': 'green-light',
  '#99e9ec': 'teal-light',
  '#abb7ff': 'blue-light',
  '#b8b8b8': 'gray-light',
}

/**
 * Case-insensitive map for legacy color transformation
 */
export const LEGACY_COLOR_MAP = new Proxy(LEGACY_HEX_TO_TAG_COLOR, {
  get(target, prop: string | symbol) {
    if (typeof prop === 'string') {
      return target[prop.toLowerCase()]
    }
    return undefined
  },
})
